import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useLocalizeMessage, Select, Table, Badge } from 'libs.nucleus';
import { AuthContext, useApiClient, ApiClientService } from 'libs.react_internal';
import { DataTransferTemplateContext } from '../../../contexts/data_transfer_template/data_transfer_template.context';
export const CloneTransferTemplateStep2 = () => {
    const translate = useLocalizeMessage();
    const { entityId, user } = useContext(AuthContext);
    const { statusOptions, setCreateTemplateFormData, packageTypeOptions, fileExtensionOptions, timezoneOptions, setIsCreateFormValid, defaultFormValues, } = useContext(DataTransferTemplateContext);
    const webClient = useApiClient(ApiClientService.WEB);
    const [status, setStatus] = useState({ label: translate('-'), value: '' });
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const retrieveTransferTemplates = async () => {
        const { data } = await webClient.post(`/api/data_transfer/templates/list`);
        return data;
    };
    const { data: transferTemplates = [], isLoading } = useQuery({
        queryKey: ['entities', entityId, 'transfer_templates'],
        queryFn: retrieveTransferTemplates,
        enabled: !!user && !!entityId,
    });
    const columns = useMemo(() => [
        {
            header: translate('Template name'),
            accessorKey: 'name',
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
        },
        {
            header: translate('Is global'),
            accessorKey: 'isGlobal',
            cell: ({ row }) => row.original.isGlobal ? _jsx(Badge, { label: translate('Yes') }) : _jsx(Badge, { label: translate('No') }),
        },
    ], []);
    const renderCustomHeaderContent = () => {
        return (_jsx(Select, { label: translate('Status'), options: statusOptions, value: status, onChange: (option) => setStatus(option), width: 'full' }));
    };
    const filteredTransferTemplates = useMemo(() => transferTemplates.filter((template) => status.value === '' || template.status === status.value), [transferTemplates, status]);
    useEffect(() => {
        const selectedTemplate = filteredTransferTemplates.find((template) => template.id === selectedTemplateId);
        if (selectedTemplate) {
            setCreateTemplateFormData({
                ...selectedTemplate,
                name: `${selectedTemplate.name} (Clone)`,
                id: '',
            });
            setIsCreateFormValid(true);
        }
        else {
            setIsCreateFormValid(false);
        }
    }, [
        selectedTemplateId,
        filteredTransferTemplates,
        setCreateTemplateFormData,
        packageTypeOptions,
        fileExtensionOptions,
        timezoneOptions,
        setIsCreateFormValid,
        defaultFormValues,
    ]);
    return (_jsx("div", { className: 'flex flex-col items-center justify-center size-full', children: _jsxs("div", { className: 'min-w-[70%] space-y-4', children: [_jsx("div", { className: 'text-lg font-semibold', children: translate('Select a template to clone') }), _jsx(Table, { columns: columns, data: filteredTransferTemplates, isLoading: isLoading, hasPagination: true, initialPageSize: 5, paginationNavigationScreenReaderLabel: translate('Pagination navigation'), isSelectable: true, isSingleSelect: true, getRowId: (row) => row.id || '', selectedIds: selectedTemplateId ? [selectedTemplateId] : undefined, onRowSelectionChange: (ids) => setSelectedTemplateId(ids[0]), useInternalSearch: true, customHeaderContent: renderCustomHeaderContent() })] }) }));
};
